import { makeNumbersFarsi } from '../utils/farsi'
import Price from './price'
import { ImageWithSkeleton } from './ImageWithSkeleton'
import { WishlistButton } from './WishlistButton'
import { ProductImage, getBestImageUrl, getImageAlt } from 'utils/imageUtils'
import { Link } from 'react-router-dom'
import { slugify } from 'utils/slugify'

// const BOOK_STORY_API_URL = 'https://api.gobookstory.com'

type Props = {
  id: string
  author: string
  title: string
  imageUrl: ProductImage
  price: number
  compareAtPrice?: number | null
}

export const Card = ({
  author,
  title,
  imageUrl,
  price,
  id,
  compareAtPrice,
}: Props) => {
  const currency = 'IRR'
  return (
    <div
      className='overflow-hidden p-4 rounded-lg flex flex-col justify-between transition-colors duration-300 relative'
      style={{
        backgroundColor: 'var(--card-bg)',
        color: 'var(--text-primary)',
        boxShadow: 'var(--card-shadow)',
        border: '1px solid var(--border-color)',
      }}
    >
      <div className='absolute top-6 right-6 z-10'>
        <WishlistButton productId={id} size={20} />
      </div>
      <Link to={`/products/${slugify(title)}`} state={{ productId: id }} target='_blank' rel='noopener noreferrer'>
        <ImageWithSkeleton
          src={getBestImageUrl(imageUrl, true)}
          alt={getImageAlt(imageUrl?.alt, title, 0)}
          title={imageUrl?.title || getImageAlt(imageUrl?.alt, title, 0)}
          containerClassName='h-64 w-full'
          className='w-full h-full object-contain object-center'
          loading='lazy'
        />
        <div className='flex flex-col items-center h-[40%] justify-evenly py-4'>
          <h1 className='w-full text-base font-semibold mt-1 text-center'>
            {makeNumbersFarsi(title)}
          </h1>
          <h1 className='w-full text-center text-base mt-1 font-semibold'>
            {author}
          </h1>

          <div className='mt-1 flex flex-col items-center'>
            {compareAtPrice ? (
              <>
                <span
                  className='text-sm mb-1'
                  style={{
                    color: 'var(--text-secondary)',
                    textDecoration: 'line-through',
                    textDecorationThickness: '2px',
                    textDecorationColor: 'var(--text-secondary)',
                    fontSize: '23px',
                  }}
                >
                  <Price
                    value={price}
                    currencyCode={currency}
                    alternativeCurrencyCode={true}
                  />
                </span>
                <Price
                  value={compareAtPrice}
                  currencyCode={currency}
                  alternativeCurrencyCode={true}
                />
              </>
            ) : (
              <Price
                value={price}
                currencyCode={currency}
                alternativeCurrencyCode={true}
              />
            )}
          </div>
        </div>
      </Link>
    </div>
  )
}
